import {Yii} from "libraries/interfaces/Yii";

// Angular
import { Component, OnInit } from '@angular/core';

// Rxjs

// Afidium
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';
import { wenji } from "libraries/interfaces/IWenji";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'iaqobohotel',
    template: `
        <div class="app-wrapper" [class.full-page]="fullPage">
            <breadcrumb></breadcrumb>
            <router-outlet></router-outlet>
        </div>
    `,
    styleUrls: ['./iaqobohotel.component.css']
})
export class IaqobohotelComponent implements OnInit {
    public fullPage: boolean;
    private breadcrumbItems = [
        {
            id: 1,
            code: 'search',
            name: Yii.t("wui-iqbh-js", "Recherche d'hébergement"),
            active: true,
            router: '/iaqobohotel/search',
            disabled: false
        },
        {
            id: 2,
            code: 'quotation',
            name: Yii.t("wui-iqbh-js", "Cotation"),
            active: false,
            router: '/iaqobohotel/quotation',
            disabled: true
        },
        {
            id: 3,
            code: 'booking',
            name: Yii.t("wui-iqbh-js", "Réservation"),
            active: false,
            router: 'booking',
            disabled: true
        }
    ];

    constructor (
        private readonly breadcrumbService: BreadcrumbService,
        private readonly router: Router,

    ) { }

    public ngOnInit (): void {
        this.breadcrumbService.setItems(this.breadcrumbItems);
        this.setAppName();
        this.fullPage = this.router.url.split('/').includes('booking');
    }

    /*
    * setAppName
    * store AppName in session storage for Header
    */
    private setAppName (): void {
        document.title = wenji.iaqobohotel.name;
        sessionStorage.setItem('childAppName', wenji.iaqobohotel.name);
    }
}
